import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { map, range } from 'lodash';
import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  SelectInput,
  SelectOption,
  baseSelectStyles,
  getCurrentSelectedOption,
  getNewSelectionValue,
} from '../rselect/ReactSelectUtils';
import UnsortedSelect from '../rselect/UnsortedSelect';
import { useDispatch } from 'react-redux';
import { setCurrentPath } from 'js/actions';

const selectStyles = {
  ...baseSelectStyles,
  control: (styles) => ({
    ...styles,
    minHeight: 38,
    borderRadius: 8,
  }),
  container: (styles) => ({
    ...styles,
    width: 75,
    height: 38,
    fontSize: 12,
  }),
  option: (styles) => ({
    ...styles,
    padding: '0 12px',
    fontSize: 12,
    lineHeight: '32px',
  }),
};

function CardsListPageNumbers(props) {
  const { isLoading, disableHistoryUpdate = false, onChange } = props;

  const dispatch = useDispatch();

  let currentPage, totalPages, totalItems;
  if (props.listing) {
    currentPage = props.listing.currentPage;
    totalPages = props.listing.totalPages;
    totalItems = props.listing.totalItems;
  } else {
    currentPage = Number(props.currentPage);
    totalPages = Number(props.totalPages);
    totalItems = Number(props.totalItems);
  }

  if (!totalItems) {
    return null;
  }

  const pageNumberOptions = map(range(1, totalPages + 1), (page) => ({
    label: page,
    value: page,
  }));
  const selectedOption = getCurrentSelectedOption(pageNumberOptions, currentPage || 1);

  const prevButtonEnabled = !isLoading && currentPage > 1;
  const nextButtonEnabled = !isLoading && currentPage < totalPages;

  const _handlePrevPageClicked = () => {
    let currentPage;
    if (props.listing) {
      currentPage = props.listing.currentPage;
    } else {
      currentPage = props.currentPage;
    }
    _setPage(currentPage - 1);
  };

  const _handleNextPageClicked = () => {
    let currentPage;
    if (props.listing) {
      currentPage = props.listing.currentPage;
    } else {
      currentPage = props.currentPage;
    }
    _setPage(currentPage + 1);
  };

  const _handlePageNumberChanged = (selectedOption) => {
    _setPage(getNewSelectionValue(selectedOption, true, ''));
  };

  const _setPage = (page) => {
    const { history, setCurrentPage } = props;

    if (props.onListingChange) {
      props.onListingChange({ type: 'updateCurrentPage', value: page });
    } else {
      if (onChange) {
        onChange(page);
      }
      if (!disableHistoryUpdate) {
        const params = new URLSearchParams(history.location.search);
        params.set('page', page);
        history.push({
          pathname: history.location.pathname,
          search: params.toString(),
        });
        dispatch(setCurrentPath(`${history.location.pathname}?${params.toString()}`));
      }

      setCurrentPage(page);
    }
  };

  const _disableClickOnLoading = (handler) => {
    return (...args) => {
      const { isLoading } = props;

      if (!isLoading) {
        return handler(...args);
      }
    };
  };

  return (
    <div className="cards-list-page-numbers">
      <IconButton
        disabled={!prevButtonEnabled}
        onClick={prevButtonEnabled ? _disableClickOnLoading(_handlePrevPageClicked) : undefined}
      >
        <ChevronLeftIcon />
      </IconButton>
      <UnsortedSelect
        options={pageNumberOptions}
        components={{ Input: SelectInput, Option: SelectOption }}
        isClearable={false}
        isSearchable={true}
        isDisabled={isLoading}
        backspaceRemovesValue={false}
        value={selectedOption}
        onChange={_handlePageNumberChanged}
        styles={selectStyles}
      />
      <IconButton
        disabled={!nextButtonEnabled}
        onClick={nextButtonEnabled ? _disableClickOnLoading(_handleNextPageClicked) : undefined}
      >
        <ChevronRightIcon />
      </IconButton>
    </div>
  );
}

export default withRouter(CardsListPageNumbers);
